import { useMemo } from "react";
import { KeyedMutator } from "swr";

import { ApiError } from "../../../api/common";
import { UserProfile, useUserProfile } from "../../../api/profile";
import { Profile } from "../ProfileDetailView";

type useProfileProps = {
    profile: Profile | undefined;
    error: ApiError | undefined;
    mutate: KeyedMutator<UserProfile>;
    isValidating: boolean;
};

export const transformUserProfileToProfile = (
    profile: UserProfile,
): Profile => ({
    id: profile.id || undefined,
    profileName: profile.name,
    profileType: profile.type,
    profileCountryCity: profile.location,
    contactPersonName: profile.contactPersonName,
    contactPersonNumber: profile.contactPersonNumber,
    contactPersonEmail: profile.contactPersonEmail,
});

const useProfile = (id: string): useProfileProps => {
    const { data, error, mutate, isValidating } = useUserProfile(Number(id));
    const profile: Profile | undefined = useMemo(
        () => data && transformUserProfileToProfile(data),
        [data],
    );

    return {
        profile,
        error,
        mutate,
        isValidating,
    };
};

export default useProfile;
